import React from 'react'

export default function HighlightRect({ rect }) {
  const width = rect.right - rect.left
  const height = rect.bottom - rect.top

  return <rect x={rect.left} y={rect.top} width={width} height={height} />
}
